import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_REJECT_CLAIM } from "../../action-types/actions";

export const rejectClaim = createAsyncThunk(
  ACTIONS_REJECT_CLAIM.rejectClaim,
  async ({ claimId, reason }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claimsReject.replace(
          "{claimId}",
          claimId,
        )}`,
        { reason },
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Claim rejected successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to reject claim");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error rejecting claim:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while rejecting the claim";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
